import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import icons from './icons';
import './icon.css';

class Icon extends PureComponent {
  render() {
    const { className, styles, onMouseEnter, onMouseLeave } = this.props;

    const cssClass = className
      ? `icon ${className}`
      : this.props.size
      ? `icon icon-${this.props.size}`
      : `icon`;

    return (
      <span
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...this.props}
      >
        {icons[this.props.name](cssClass, styles)}
      </span>
    );
  }
}

Icon.propTypes = {
  styles: PropTypes.shape({}),
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  sm: PropTypes.bool,
  md: PropTypes.bool,
  lg: PropTypes.bool,
  xl: PropTypes.bool,
  xxl: PropTypes.bool,
};

export default Icon;
export { default as icons } from './icons';



// WEBPACK FOOTER //
// ./src/ui/src/component/icon/icon.js